/**
 * @format
 * @Description: 登录日志请求层
 * @Autho: 方证
 * @Date: 2019/12/10
 */

import Request from 'utils/request';
import Cookie from 'js-cookie';

export default class LogLoginServ {
  static addOrganization(params) {
    return Request({
      url: `api/user/v1/organization/org/info`,
      headers: {
        'Content-type': 'application/json;charset=UTF-8',
        'Access-Token': Cookie.get('boc_auth')
      },
      method: 'POST',
      data: params
    });
  }
  static getList(params) {
    return {
      method: 'get',
      url: `api/identity/v3/user/log`
    };
  }
}



// WEBPACK FOOTER //
// ./src/pages/LogManage/LogLogin/LogLoginServ.js